import { render } from "./public-add-doctor.vue?vue&type=template&id=a167ae88&scoped=true"
import script from "./public-add-doctor.vue?vue&type=script&lang=js"
export * from "./public-add-doctor.vue?vue&type=script&lang=js"

import "./public-add-doctor.vue?vue&type=style&index=0&id=a167ae88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a167ae88"]])

export default __exports__